var _path, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.9 44.2l-4.4-22.1c-1-5.1-5.4-9-10.7-9.1H17.3c-5.4 0-9.9 3.9-10.8 9.1L2.1 44.2c-.1.4-.1.8-.1 1.2C2 48.5 4.5 51 7.5 51c2 0 3.7-1 4.7-2.6l7.2-9c1.2 1.1 2.7 1.8 4.4 1.8c3.6 0 6.5-2.9 6.5-6.6h3.5c0 3.6 2.9 6.6 6.5 6.6c1.7 0 3.2-.6 4.4-1.7l7.2 9c1 1.6 2.7 2.6 4.7 2.6c3 0 5.5-2.5 5.5-5.6c-.1-.5-.1-.9-.2-1.3",
    fill: "#333"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#94989b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9 25.2c.7.7 1.5.5 1.8-.5v-3.1c-.3-1-1.1-1.2-1.8-.5l-.7.7c-.7.7-.7 1.9 0 2.6l.7.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8 17.8c-1 .3-1.2 1.1-.5 1.8l.7.7c.7.7 1.9.7 2.6 0l.7-.7c.7-.7.5-1.5-.5-1.8h-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 21.2c-.7-.7-1.5-.5-1.8.5v3.1c.3 1 1.1 1.2 1.8.5l.7-.7c.7-.7.7-1.9 0-2.6l-.7-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9 28.7c1-.3 1.2-1.1.5-1.8l-.7-.7c-.7-.7-1.9-.7-2.6 0l-.7.7c-.7.7-.5 1.5.5 1.8h3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#f2b200"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5 23.2c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8s1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2 25.1c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8s1.8-.8 1.8-1.8c.1-1-.8-1.8-1.8-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3 21.4c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8c0 .9.8 1.8 1.8 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1 23.2c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8s.8 1.8 1.8 1.8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#94989b"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.3,
    cy: 34.5,
    rx: 4.3,
    ry: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8 30.1c-2.4 0-4.3 2-4.3 4.4c0 2.4 1.9 4.4 4.3 4.4s4.3-2 4.3-4.4c.1-2.4-1.9-4.4-4.3-4.4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app.a38063cc60d69c09c2755082d6430d8f.svg";
export { ForwardRef as ReactComponent };